<script lang="ts">
    import { STATUS } from "@/constants/statuses";
    import { createProductInfoObservable } from "@apps/instagram/utils/createProductInfoObservable";
    import type TikTokPostTagEntity from "@apps/tiktok/entities/TikTokPostTagEntity";
    import { tikTokGalleryWidgetContextToken } from "@apps/tiktok/widgets/tiktok_gallery_widget/context_tokens";
    import { getTypedContext } from "@lib/svelte-typed-context";
    import { URLsBuilder } from "@modules/common_module/URLsBuilder/URLsBuilder";
    import Observable from "@ui-utils/Observable.svelte";

    import PostModalProductTagCard from "@components/PostModal/PostModalProductTagCard.svelte";

    export let activeMediaTags: TikTokPostTagEntity[];
    export let selectedTagId: number | null = null;
    export let productQuickViewEnabled: boolean;
    export let urlsBuilder: URLsBuilder;

    const { productsQuery } = getTypedContext(tikTokGalleryWidgetContextToken);

    $: isSelectedTagId = (tagId: number): boolean => selectedTagId === tagId;
</script>

<div class="gw-tt-post-modal-tags-list">
    {#if activeMediaTags}
        {#each activeMediaTags as tag (tag.id)}
            <Observable
                observable={createProductInfoObservable(
                    productsQuery,
                    tag.product.id,
                    tag.variantId
                )}
                let:value
            >
                {#if value.status === STATUS.READY}
                    <PostModalProductTagCard
                        on:tag_select
                        on:tag_unselect
                        on:tag_open
                        selected={isSelectedTagId(tag.id)}
                        {productQuickViewEnabled}
                        imageUrl={(value.variant?.image?.url &&
                            urlsBuilder.createProductImageUrl(
                                value.variant?.image?.url
                            )) ||
                            (value.product.featuredImage?.url &&
                                urlsBuilder.createProductImageUrl(
                                    value.product.featuredImage?.url
                                ))}
                        comparePrice={value.variant?.compareAtPrice?.amount ||
                            null}
                        price={value.variant?.price?.amount ||
                            value.product.variants[0].price.amount}
                        tagId={tag.id}
                        title={value.product.title}
                        url={urlsBuilder.createProductUrl(value.product.handle)}
                        variantTitle={value.variant?.title}
                    />
                {/if}
            </Observable>
        {/each}
    {/if}
</div>

<style>
    .gw-tt-post-modal-tags-list {
        box-sizing: border-box;
        width: 100%;
        height: 100%;
    }
    @media all and (max-width: 768px) {
        .gw-tt-post-modal-tags-list {
            position: relative;
        }
    }
</style>
